import { PageType } from './types';

export default {
  '/apps/NewInvoice.do': {
    [PageType.list]: '/platform/apps/com_zuora/invoice',
    [PageType.detail]: '/platform/apps/com_zuora/invoice/{{Id}}',
    [PageType.edit]: '/platform/apps/com_zuora/invoice/{{Id}}',
    [PageType.create]: '/platform/apps/com_zuora/invoice/create',
  },
  '/apps/NewBillingRun.do': {
    [PageType.list]: '/platform/apps/com_zuora/billrun',
    [PageType.detail]: '/platform/apps/com_zuora/billrun/{{Id}}',
    [PageType.edit]: '/platform/apps/com_zuora/billrun/{{Id}}',
    [PageType.create]: '/platform/apps/com_zuora/billrun/create',
  },
  '/apps/Usages.do': {
    [PageType.list]: '/platform/apps/com_zuora/usage',
    [PageType.detail]: '/platform/apps/com_zuora/usage/{{Id}}',
    [PageType.edit]: '/platform/apps/com_zuora/usage/{{Id}}',
    [PageType.create]: '/platform/apps/com_zuora/usage/create',
  },
  '/apps/Product.do': {
    [PageType.list]: '/platform/apps/com_zuora/productcatalog',
    [PageType.detail]: '/platform/apps/com_zuora/productcatalog/{{Id}}',
    [PageType.edit]: '/platform/apps/com_zuora/productcatalog/{{Id}}',
    [PageType.create]: '/platform/apps/com_zuora/productcatalog/create',
  },
  '/apps/Feature.do': {
    [PageType.list]: '/platform/apps/com_zuora/feature',
    [PageType.detail]: '/platform/apps/com_zuora/feature/{{Id}}',
    [PageType.edit]: '/platform/apps/com_zuora/feature/{{Id}}',
    [PageType.create]: '/platform/apps/com_zuora/feature/create',
  },
  '/apps/NewPayment.do': {
    [PageType.list]: '/platform/apps/com_zuora/payment',
    [PageType.detail]: '/platform/apps/com_zuora/payment/{{Id}}',
    [PageType.edit]: '/platform/apps/com_zuora/payment/{{Id}}',
    [PageType.create]: '/platform/apps/com_zuora/payment/create',
  },
  '/apps/ARPayment.do': {
    [PageType.list]: '/platform/apps/com_zuora/payment',
  },
  '/apps/PaymentRun.do': {
    [PageType.list]: '/platform/apps/com_zuora/paymentrun',
    [PageType.detail]: '/platform/apps/com_zuora/paymentrun/{{Id}}',
    [PageType.edit]: '/platform/apps/com_zuora/paymentrun/{{Id}}',
    [PageType.create]: '/platform/apps/com_zuora/paymentrun/create',
  },
  '/apps/NewPaymentMethod.do': {
    [PageType.list]: '/platform/apps/com_zuora/paymentmethod',
    [PageType.detail]: '/platform/apps/com_zuora/paymentmethod/{{Id}}',
    [PageType.edit]: '/platform/apps/com_zuora/paymentmethod/{{Id}}',
    [PageType.create]: '/platform/apps/com_zuora/paymentmethod/create',
  },
  '/apps/ARRefund.do': {
    [PageType.list]: '/platform/apps/com_zuora/refund',
    [PageType.detail]: '/platform/apps/com_zuora/refund/{{RefundNumber}}',
    [PageType.edit]: '/platform/apps/com_zuora/refund/{{RefundNumber}}',
    [PageType.create]: '/platform/apps/com_zuora/refund/create',
  },
  '/apps/NewRefund.do': {
    [PageType.list]: '/platform/apps/com_zuora/refund',
    [PageType.detail]: '/platform/apps/com_zuora/refund/{{RefundNumber}}',
    [PageType.edit]: '/platform/apps/com_zuora/refund/{{RefundNumber}}',
    [PageType.create]: '/platform/apps/com_zuora/refund/create',
  },
  '/apps/JournalRuns.dox': {
    [PageType.list]: '/platform/apps/com_zuora/journalrun',
    [PageType.detail]: '/platform/apps/com_zuora/journalrun/{{Number}}',
    [PageType.edit]: '/platform/apps/com_zuora/journalrun/{{Number}}',
    [PageType.create]: '/platform/apps/com_zuora/journalrun/create',
  },
  '/apps/AccountingPeriods.dox': {
    [PageType.list]: '/platform/apps/com_zuora/accountingperiod',
    [PageType.detail]: '/platform/apps/com_zuora/accountingperiod/{{Id}}',
    [PageType.edit]: '/platform/apps/com_zuora/accountingperiod/{{Id}}',
    [PageType.create]: '/platform/apps/com_zuora/accountingperiod/create',
  },
  '/orders': {
    // Current Orders is UNSAFE to redirect
    // https://zuora.atlassian.net/browse/PD-629
    // [PageType.list]: '/platform/apps/com_zuora/order',
    // [PageType.detail]: '/platform/apps/com_zuora/order/{{OrderNumber}}',
    // [PageType.edit]: '/platform/apps/com_zuora/order/{{OrderNumber}}',
    // [PageType.create]: '/platform/apps/com_zuora/order/create',
  },
  '/apps/UpdaterBatch.do': {
    [PageType.list]: '/platform/apps/com_zuora/updaterbatch',
    [PageType.detail]: '/platform/apps/com_zuora/updaterbatch/{{BatchNumber}}',
    [PageType.edit]: '/platform/apps/com_zuora/updaterbatch/{{BatchNumber}}',
    [PageType.create]: '/platform/apps/com_zuora/updaterbatch/create',
  },
  '/apps/Reconciliation.do': {
    [PageType.list]: '/platform/apps/com_zuora/paymentreconciliationjob',
    [PageType.detail]:
      '/platform/apps/com_zuora/paymentreconciliationjob/{{Id}}',
    [PageType.edit]: '/platform/apps/com_zuora/paymentreconciliationjob/{{Id}}',
    [PageType.create]:
      '/platform/apps/com_zuora/paymentreconciliationjob/create',
  },
  // TODO: This will always route to Credit Memo. The existing screen has both on the same page, so it's impossible to tell via URL which to go to.
  '/apps/ARSettlement.do': {
    [PageType.list]: '/platform/apps/com_zuora/creditdebitmemos',
    [PageType.detail]: '/platform/apps/com_zuora/creditmemo/{{Id}}',
    [PageType.edit]: '/platform/apps/com_zuora/creditmemo/{{Id}}',
    [PageType.create]: '/platform/apps/com_zuora/creditmemo/create',
  },
};
